import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
// import { devLoggerInterceptor } from './interceptors/dev-logger.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './interceptors/auth.interceptor';
import { HeaderInterceptor } from './interceptors/header.interceptor';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { unauthCommunityInterceptor } from './interceptors/unauth-community.interceptor';
import { timeoutInterceptor } from './interceptors/timeout.interceptor';
import { watchdogInterceptor } from './interceptors/watchdog.interceptor';
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
} from '@abacritt/angularx-social-login';

// Dynamic domain-specific route sets
import { ROUTES_DOMAIN_A } from './routes-domain-a';
import { ROUTES_DOMAIN_B } from './routes-domain-b';

const hostname = window.location.hostname;

// Debug output
console.log(
  '%c[AppConfig Debug] Hostname:',
  'color: limegreen; font-weight: bold;',
  hostname,
);

const selectedRoutes = (() => {
  if (
    // community routes
    hostname === 'community.staging.connect.kontactapp.com' ||
    hostname === 'community.connect.kontactapp.com' ||
    hostname === 'community-staging.komudu.com' ||
    hostname === 'community.komudu.com' ||
    hostname === 'domain-a.local'
  ) {
    console.log(
      '%c[AppConfig Debug] Using ROUTES_DOMAIN_A',
      'color: dodgerblue; font-weight: bold;',
    );
    return ROUTES_DOMAIN_A;
  } else if (
    // profile routes
    hostname.includes('profile.staging.connect.kontactapp.com') ||
    hostname.includes('profiles.connect.kontactapp.com') ||
    hostname.includes('kon.tc') ||
    hostname.includes('domain-b.local')
  ) {
    console.log(
      '%c[AppConfig Debug] Using ROUTES_DOMAIN_B',
      'color: orange; font-weight: bold;',
    );
    return ROUTES_DOMAIN_B;
  } else {
    console.warn(
      '[AppConfig Debug] Unknown domain, defaulting to ROUTES_DOMAIN_A',
    );
    return ROUTES_DOMAIN_A;
  }
})();

// Log all selected route paths
console.log(
  '%c[AppConfig Debug] Selected route paths:',
  'color: teal;',
  selectedRoutes.map((r) => r.path),
);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(selectedRoutes),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        HeaderInterceptor,
        unauthCommunityInterceptor,
        timeoutInterceptor,
        watchdogInterceptor,
      ]),
    ),
    provideToastr(),
    provideAnimations(),
    MdbModalService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '1035283790663-ico8u02sv6285v21ksu9o3e786fgqiua.apps.googleusercontent.com',
            ),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('271160823985290', {
              scope: 'email,public_profile',
              return_scopes: true,
            }),
          },
        ],
      } as SocialAuthServiceConfig,
    },
  ],
};
